import axios from '../services/api';
import log from '../utils/logger';

export const createNotificationClickHandler = (navigate, updateNotifications) => {
  return async (notification) => {
    // Mark as delivered in backend
    try {
      await axios.patch(`/notifications/${notification.id || notification._id}/read`);
    } catch (error) {
      log.error('Error marking notification as delivered:', error);
    }
    
    // Remove from local state
    updateNotifications(prev => prev.filter(n => (n.id || n._id) !== (notification.id || notification._id)));
    
    if (notification.action) {
      if (notification.contextId) {
        navigate(`/${notification.action}/${notification.contextId}`);
      } else {
        navigate(`/${notification.action}`);
      }
    }
  };
};